import React, { useCallback, useState } from 'react'
import PatientSuperSearch from 'NewComponents/UtilityComponents/PatientSuperSearch/PatientSuperSearch'
import { DataGrid } from 'Common/CusomReactGrid/CustomDataGrid';
import api from 'http';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import ReactPortal from 'Components/ReactPortal/ReactPortal';
import ConfirmationPopup from 'Popups/ConfirmationPopup/ConfirmationPopup';
import NumberConversion from 'Utils/NumberConversion';
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';
import CustomDraggable from 'Common/CustomDraggable/CustomDraggable';
import useDebounce from 'CustomHooks/useDebounce';
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import CustomInput from 'Common/CustomInput/CustomInput';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { swtichTab } from "Redux/TabsSlice/TabsSlice";

const url = process.env.REACT_APP_TC_PMS + `/api`
const pmsApiUrl = process.env.REACT_APP_TC_PMS;

const AddClaimPopup = ({ onClose, handlePaymentDetail, patientDetail, paymentDetail, paymentFrom, disableDraggable }) => {
    const UNIQUE_ID = "AddClaimPopup"
    const [state, setState] = useState({
        perPage: 10,
        pageNo: 1,
        totalRows: 10,
        patientSearch: (paymentFrom || ""),
        overPaymentPopup: false,
        notSubmitPopup: false,
        isLoading: false,
        currentRow: null,
        planExistPopup: false,

    })
    const visitStatus = useSelector((state) => state.dataSlice.ClaimStatusCodes);
    const [selectedRows, setSelectedRows] = useState(new Set())
    const [paymentModel, setPaymentModel] = useState({
        patientId: "",
        visitId: "",
        checkdate: "",
        name: "",
        checkno: ""
    })
    const debouncedSearchTerm = useDebounce(paymentModel.visitId, 500);
    const dispatch = useDispatch();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPaymentModel((prevModel) => ({
            ...prevModel,
            [name]: value,
        }));
    };
    const handleSelectedData = (selectedObj, name) => {

        if (selectedObj) {
            // setRows([selectedObj])
            setPaymentModel((prev) => ({
                ...prev,
                name: selectedObj.name,
                patientId: selectedObj.id
            }))
            handleSearch(selectedObj.id)
        } else {
            setPaymentModel((prev) => ({
                ...prev,
                name: "",
                patientId: ""
            }))
        }
    };
    const handleEnter = (e) => {
        if (e.charCode === 13) {
            handleSearch();
        }
    }

    const gotoCharge = (row) => {
        dispatch(
            swtichTab({
                parentName: "charges",
                subTabName: "claim",
                subTabData: row
            })
        );
        onClose();
        // dispatch(swtichTab({ parentName: "charges", subTabName: "visit", subTabData: row }))
    }
    const handleClaimPayment = (row) => {
        if (!patientDetail?.patientId) {
            if (row.isPlanExist === 0) {

                setState({ ...state, planExistPopup: true, currentRow: row })
            }
            else if (!row.isSubmitted) {
                if (!row.primaryPayer) {
                    toast.info("No Patient Plan found.")
                } else {
                    setState({ ...state, notSubmitPopup: true, currentRow: row })
                }
            }
            else if (row.claimBalance === 0) {

                setState({ ...state, overPaymentPopup: true, currentRow: row })
            } else {
                handlePaymentDetail(row, "")
            }
        } else {
            handlePaymentDetail(row, "")
        }

    }
    const patientwiseColumn = [
        {
            name: "Claim #",
            key: "id",
            formatter: ({ row }) => {
                return <span className='font-semibold cursor-pointer text-primaryColor hover:underline' onClick={() => handleClaimPayment(row)}>{row.id}</span>
            }
        },
        {
            name: "Claim Status",
            width: 175,
            key: "claimStatusCode",
            formatter: ({ row }) => {
                if (!row.claimStatusCode) return "";
                const statusInfo = visitStatus.find(
                    (statusCode) => statusCode.statusCode === row.claimStatusCode
                );

                if (!statusInfo) return "";
                const statusDescription = statusInfo.statusDescription;
                if (row.claimStatusCode === "P") {
                    return (
                        <div className="space-y-1">

                            <div className={`status-pill  ${row.claimStatusCode === "P" && "status-pill-paid"}`}>
                                {statusDescription}
                            </div>
                            {process.env.REACT_APP_DEVELOPMENT && <div className="text-xs text-secondaryLight"><b>Responsible Party:</b> {row.responsibleParty || "None"}</div>}
                        </div>


                    );
                }

                return <>
                    {statusDescription}
                    {process.env.REACT_APP_DEVELOPMENT && <div className="text-xs text-secondaryLight"><b>Responsible Party:</b> {row.responsibleParty || "None"}</div>}
                </>;
            },
        },
        {
            name: "Billed Amount",
            key: "totalAmount",
            formatter: ({ row }) => NumberConversion(row.totalAmount)
        },
        {
            name: "Primary Paid",
            key: "primaryPaid",
            formatter: ({ row }) => NumberConversion(row.primaryPaid)
        },
        {
            name: "Secondary Paid",
            key: "secondaryPaid",
            formatter: ({ row }) => NumberConversion(row.secondaryPaid)
        },
        {
            name: "Patient Paid",
            key: "patientPaid",
            formatter: ({ row }) => NumberConversion(row.patientPaid)
        },
        {
            name: "Balance (PR)",
            key: "pr",
            formatter: ({ row }) => NumberConversion(row.pr)
        },
    ]
    const columns = [
        {
            name: "Claim #", key: "visitId", formatter: ({ row }) => {
                return <span className='font-semibold cursor-pointer text-primaryColor' onClick={() => handleClaimPayment(row)}>{row.visitId}</span>
            }
        },
        { name: "Claim Status", key: "claimStatus" },
        { name: "Patient Name", key: "patientName" },
        {
            name: "Total Charges", key: "totalCharges",
            formatter: ({ row }) => NumberConversion(row.totalCharges)

        },
        { name: "Date Of Service", key: "dosFrom" },
        {
            name: "Claim Balance", key: "claimBalance",
            formatter: ({ row }) => NumberConversion(row.claimBalance)
        },
        // { name: "Total Amount", key: "totalAmount" },
        // { name: "Write Off", key: "writeOff" },

    ]

    const [rows, setRows] = useState([]);


    const handlePageChange = (pageno) => {
        setPaymentModel({ ...paymentModel, pageNo: pageno });
    };
    const handlePerRowsChange = (rowsPerPage, pageno) => {
        setPaymentModel({ ...paymentModel, pageNo: pageno, perPage: rowsPerPage });
        // setRowsPerPage(rowsPerPage)
    };

    const handleSearch = useCallback(async (patId = 0) => {
        setState(prev => ({ ...prev, isLoading: true }))
        setSelectedRows(new Set()) // Clear selections on new search
        if (patientDetail?.patientId) {
            // Use the new API endpoint
            api.get(
                `${pmsApiUrl}/api/patientpayment/v2/GetDuePatientVisitPaymentsByPaymentMain`,
                {
                    params: {
                        patientId: patientDetail?.patientId,
                        paymentMainId: paymentDetail?.id || 0,
                        allPatientVisit: true,
                    },
                }
            )
                .then(async res => {
                    if (res.data.dataModel) {
                        const filteredClaims = res.data.dataModel.filter(claim => claim.status !== 'Paid')
                        if (filteredClaims.length > 0) {
                            setRows(filteredClaims)
                            setState(prev => ({
                                ...prev, claims: filteredClaims,
                                isLoading: false
                            }))
                        } else {
                            toast("No Claims Found !", { type: "error" })
                            setState(prev => ({ ...prev, isLoading: false }))
                        }
                    } else {
                        toast("No Claims Found !", { type: "error" })
                        setState(prev => ({ ...prev, isLoading: false }))
                    }
                }).catch(err => {
                    setState(prev => ({ ...prev, isLoading: false }))
                    ErrorHandlingMessage(err)
                })
        } else {
            const patientId = paymentModel.patientId || patId
            const visitId = paymentModel.visitId || debouncedSearchTerm
            api.post(url + `/Payment/FindClaimForLinked`, {
                ...(patientId && { patientId }),
                ...(visitId && { visitId }),
            }).then(res => {
                if (res.data.dataModel && res.data.dataModel.data) {
                    setRows(res.data.dataModel.data)
                    setState(prev => ({ ...prev, isLoading: false }))
                } else {
                    toast("No Claims Found !", { type: "error" })
                    setState(prev => ({ ...prev, isLoading: false }))
                    setRows([])
                }
            }).catch(err => {
                setState(prev => ({ ...prev, isLoading: false }))
                setRows([])
            })
        }
    }, [debouncedSearchTerm, patientDetail?.patientId, paymentDetail?.id, paymentModel.patientId, paymentModel.visitId])

    useEffect(() => {
        if (debouncedSearchTerm.length >= 3) {
            handleSearch();
        }
    }, [debouncedSearchTerm, handleSearch]);

    useEffect(() => {
        if (patientDetail?.patientId) {
            setState(prev => ({ ...prev, isLoading: true }))
            setPaymentModel(prev => ({ ...prev, patientId: patientDetail?.patientId }))
            setSelectedRows(new Set()) // Clear selections on mount
            // Use the new API endpoint
            api.get(
                `${pmsApiUrl}/api/patientpayment/v2/GetDuePatientVisitPaymentsByPaymentMain`,
                {
                    params: {
                        patientId: patientDetail?.patientId,
                        paymentMainId: paymentDetail?.id || 0,
                        allPatientVisit: true,
                    },
                }
            )
                .then(async res => {
                    if (res.data.dataModel) {
                        const filteredClaims = res.data.dataModel.filter(claim => claim.status !== 'Paid')
                        if (filteredClaims.length > 0) {
                            setRows(filteredClaims)
                            setState(prev => ({
                                ...prev,
                                patientSearch: patientDetail.name || patientDetail.patientName,
                                isLoading: false
                            }))
                        } else {
                            toast("No Claims Found", { type: "error" })
                            setState(prev => ({ ...prev, isLoading: false }))
                        }
                    } else {
                        toast("No Claims Found", { type: "error" })
                        setState(prev => ({ ...prev, isLoading: false }))
                    }
                }).catch(err => {
                    setState(prev => ({ ...prev, isLoading: false }))
                    ErrorHandlingMessage(err)
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>

            {state.overPaymentPopup &&
                <ConfirmationPopup buttonTitle="Yes" onConfirm={() => handlePaymentDetail(state.currentRow, "overPayment")} onCancel={() => setState({ ...state, overPaymentPopup: false })} subHeading="Claim is already paid ! are you sure you want to do overpayment?" />

            }

            {state.notSubmitPopup &&
                <ConfirmationPopup buttonTitle="Yes" onConfirm={() => handlePaymentDetail(state.currentRow, "newSubmit")} onCancel={() => setState({ ...state, notSubmitPopup: false })} subHeading="Claim is not submitted yet, Do you still want to apply Payment?" />

            }

            {state.planExistPopup &&
                <ConfirmationPopup buttonTitle="Yes" onConfirm={() => gotoCharge(state.currentRow)} onCancel={() => setState({ ...state, planExistPopup: false })} subHeading="No Plan Found ! would you like to add Plan?" />
            }
            <ReactPortal wrapperId={UNIQUE_ID}>
                <div
                    data-te-modal-init
                    className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75"
                    id="exampleModalScrollable"
                    tabIndex={-1}
                    aria-labelledby="exampleModalScrollableLabel"
                    aria-modal="true"
                    data-te-open="true"
                >
                    <CustomDraggable disableDraggable={disableDraggable} handle={`#${UNIQUE_ID}`}>
                        <div
                            data-te-modal-dialog-ref
                            className="relative w-[1000px]  min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg"
                        >
                            <div
                                id={UNIQUE_ID}
                                className="flex items-center justify-between p-5 text-2xl font-semibold border-b cursor-grab"
                            >
                                Add Claim
                            </div>
                            <div className="p-5">
                                <div className="grid grid-cols-12 gap-4 ">
                                    <div className="col-span-12 md:col-span-4">
                                        {patientDetail?.patientId ? <CustomInput label="Patient Name" disabled value={(patientDetail.paymentFrom || patientDetail?.patientName)} /> : 
                                        <PatientSuperSearch
                                            label="Patient Name"
                                            searchValue={paymentModel.name}
                                            onChange={(value) => { setPaymentModel((prev) => ({ ...prev, name: value })) }}
                                            handleSelectedData={(obj) => handleSelectedData(obj, "patientId")}
                                            width='100%'
                                        />}
                                    </div>
                                    {!patientDetail?.patientId && <div className="col-span-12 md:col-span-4">
                                        <CustomInput label="Claim #" isNumeric value={paymentModel.visitId} name="visitId" onKeyPress={handleEnter} onChange={handleInputChange} toolTip="Only numeric values are allowed" />
                                    </div>}
                                    <div className="flex items-end col-span-12 ml-auto md:col-span-4">
                                        {!patientDetail?.patientId && <CustomButtonNew label="Search" onClick={() => handleSearch()} />}
                                    </div>
                                </div>

                            </div>

                            <div className="px-5 min-h-[50px] flex flex-col flex-1">
                                <DataGrid
                                    paginationDefaultPage={1}
                                    columns={!patientDetail?.patientId ? columns : patientwiseColumn}
                                    rows={rows}
                                    paginationPerPage={
                                        state.perPage
                                    }
                                    contentBasedHeight={true}
                                    contentBasedMaxHeight={450}
                                   
                                    isLoading={state.isLoading}
                                    pagination={{
                                        perPage: state.perPage,
                                        pageNo: state.pageNo,
                                        totalCount: state.totalRows,
                                    }}
                                    manualPagination={false}
                                    handlePerRowsChange={handlePerRowsChange}
                                    handlePageChange={handlePageChange}

                                // dynamicClass='allowDropDown'
                                // mainDivClass="patientSearchDynamicClass"
                                />

                            </div>
                            <div className="flex flex-wrap items-center justify-end gap-2 p-5 ">
                                <CustomButtonNew label="Cancel" variant="outline" onClick={onClose} />
                                {selectedRows.size > 0 && (
                                    <CustomButtonNew
                                        label={`Add ${selectedRows.size} Claim${selectedRows.size > 1 ? 's' : ''}`}
                                        variant="filled"
                                        onClick={() => {
                                            // Convert Set to array of row objects
                                            const selectedClaims = rows.filter(row => selectedRows.has(row.id));

                                            handlePaymentDetail(selectedClaims);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </CustomDraggable>
                </div>
            </ReactPortal>
        </>

    )
}

export default AddClaimPopup